import { getDomainInfos } from './gemDomainUtils';
import { getFormatUrlMethods, useDomainGems } from './gemUrlFormatUtils';

export function getVideoIframeUrl(options = {}) {
  const domainInfos = options?.domains || getDomainInfos();
  const videoIframeUrl = `https://${domainInfos.QCMAIN_HOST}/solution-new/tc-video`;
  return videoIframeUrl;
}

export const useFormatUrlMethods = () => {
  const domains = useDomainGems();
  return getFormatUrlMethods({ domains });
};
